import { Pagination } from '@interfaces/pagination';
import { Grid } from '@mui/material';
import { CustomPagination } from '@shared/components/CustomPagination';
import TokenCard from '@shared/components/TokenCard';
import { PAGINATION_LIMIT } from '@shared/constants/app.constant';
import TokenCardSkeleton from '@shared/skeletons/TokenCardSkeleton';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { appSelector } from '@store/slices/app.slice';
import { getHotTokensAction, getRecentTokensAction, tokenSelector } from '@store/slices/token.slice';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { AppNoToken } from '@shared/components/AppNoToken';

export const RecentTokens = ({ categoryId }: { categoryId?: string }) => {
    const appSlice = useAppSelector(appSelector)
    const tokenSlice = useAppSelector(tokenSelector);
    const dispatch = useAppDispatch();
    let history = useHistory();

    const onTokenSelect = (id: number) => {
        history.push(`public/token/${id}`)
    }

    const getTokens = (pagination: Pagination) => {
        dispatch(getRecentTokensAction({ pagination }));
    }

    useEffect(() => {
        getTokens({ page: 1, limit: PAGINATION_LIMIT })
    }, [])

    return (
        <div>
            {!tokenSlice.recentTokenLoaded && (
                <Grid container spacing={2} >
                    {[1, 2, 3].map(item => (
                        <Grid item md={4} xs={12}>
                            <TokenCardSkeleton />
                        </Grid>
                    ))
                    }
                </Grid>
            )
            }
            {tokenSlice.recentTokenLoaded && tokenSlice.recentTokens?.data?.length > 0 && (
                <>

                    <Grid container spacing={2} >
                        {tokenSlice.recentTokens?.data?.map(token => {
                            return (
                                <Grid item md={4} xs={12} key={token.id}>
                                    <TokenCard token={token} click={onTokenSelect} />
                                </Grid>
                            )
                        })}
                    </Grid>
                    <CustomPagination pagination={tokenSlice?.recentTokens?.meta} change={getTokens}
                    />
                </>
            )}

            {(!tokenSlice.recentTokens?.data || tokenSlice.recentTokens?.data?.length == 0) && (
                <AppNoToken
                    title="No tokens listed recently" body={''}>
                </AppNoToken>
            )}
        </div>
    )
}
